<template>
  <div>
    <h2 class="heading-2">
      {{ i18n(translations.footer_title) }}
    </h2>

    <p class="body-1 pb-24 pt-8">
      {{ i18n(translations.footer_instructions) }}
      <span v-if="lrrIsOngoing" data-test="lrr-text">{{
        i18n(translations.footer_late_response_rate)
      }}</span>
    </p>

    <RevButton
      size="small"
      :to="resolveLocalizedRoute({ name: DASHBOARD.MY_ORDERS.SELF })"
      variant="primary"
    >
      {{ i18n(translations.footer_instructions_cta) }}
    </RevButton>

    <FormattedMessage
      class="body-1 pb-44 pt-24"
      :definition="translations.footer_need_help_cta"
      tag="p"
    >
      <template #cta>
        <RevLink
          v-if="!isIntercomLoadComplete"
          data-qa="contact-link"
          data-test="contact-link"
          :to="linkTo"
        >
          {{ i18n(translations.footer_need_help_cta_link) }}
        </RevLink>

        <RevLink
          v-if="isIntercomLoadComplete"
          data-qa="messenger-cta"
          data-test="messenger-cta"
          @click="handleLinkClick"
        >
          {{ i18n(translations.footer_need_help_cta_link) }}
        </RevLink>
      </template>
    </FormattedMessage>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useZendeskFaqBaseUrl } from '@backmarket/nuxt-layer-base/composables/useZendeskFaqBaseUrl'
import { useIntercom } from '@backmarket/nuxt-layer-care-platform/intercom/composables/useIntercom'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevLink } from '@ds/components/Link'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { useCheckForLrr } from '~/scopes/care-commons/composables/useCheckForLrr'
import { ROUTE_NAMES } from '~/scopes/dashboard/constants'

import translations from './FooterBlock.translations'

const { DASHBOARD } = ROUTE_NAMES

const i18n = useI18n()

const { lrrIsOngoing } = useCheckForLrr()

const resolveLocalizedRoute = useRouteLocationWithLocale()
const { zendeskFaqBaseUrl } = useZendeskFaqBaseUrl()

const { intercom, status } = useIntercom()

const linkTo = `${zendeskFaqBaseUrl}/requests/new`

const isIntercomLoadComplete = computed(
  () => status.value === 'loaded' || status.value === 'error',
)

function handleLinkClick() {
  intercom('show')
}
</script>
